// Edit this file to include new api route variables

const API_ROUTE = process.env.VUE_APP_API_ROUTE
const PCH_PROVIDER = API_ROUTE + '/pch_provider/'
// GModule
const GET_MENU_USER = API_ROUTE + '/get_menu_module_user'
const GET_LOGIN_MODULE_DATA = API_ROUTE + '/get_login_module'
// Auth token
const GET_LOGIN_TOKEN = API_ROUTE + '/auth/get_login_token'
const LOGOUT_REQUEST = API_ROUTE + '/auth/logout'
// ground Seller
const GROUND_SELLER = API_ROUTE + '/sl_ground_seller'
//
const ACCOUNTING_BANK_CARD_VALIDATE = API_ROUTE +'/accounting_bank_card_chile/validate'
const ACCOUNTING_BANK_CARD_UPLOAD = API_ROUTE + '/accounting_bank_card_chile/upload'
const ACCOUNTING_BANK_CARD_CONCILIATION_UPLOAD = API_ROUTE + '/acc_bank_card_chile_conciliation/upload'
// sl_customer
const BLOCK_UNBLOCK_SL_CUSTOMER = API_ROUTE + '/sl_customer/block_unblock'

export default {
    PCH_PROVIDER,
    GET_LOGIN_MODULE_DATA,
    GET_LOGIN_TOKEN,
    GET_MENU_USER,
    LOGOUT_REQUEST,
    GROUND_SELLER,
    ACCOUNTING_BANK_CARD_VALIDATE,
    ACCOUNTING_BANK_CARD_UPLOAD,
    ACCOUNTING_BANK_CARD_CONCILIATION_UPLOAD,
    BLOCK_UNBLOCK_SL_CUSTOMER,
}
